import React, { useState, useEffect } from 'react';
import { injectIntl} from 'react-intl';
import { Route, BrowserRouter as Router, Switch, useParams } from 'react-router-dom';

import Loader from '../../components/builder/Loader';

import EntriesMultiGallery from '../../components/users/EntriesMultiGallery.js';
import MultiEntriesRanking from '../../components/users/MultiEntriesRanking.js';
import { getRemotedbUrl } from '../../lib/ep';

import GalleryMosaic from './GalleryMosaic.js';

const Gallery = (props) => {
	const {stage_id} = useParams();
	const stage = props.stages.find((s) => s.Stage.id == stage_id);

	const [ avail_participations, setAvailParticipations ] = useState(false);

	useEffect(() => {
		$.get(getRemotedbUrl(`/stages/getAvailableParticipations/${props.promotion.id}/${stage_id}`), (res) => {
			setAvailParticipations(res);
		}, 'JSON');
	},[]);

	if(avail_participations == false) {
		return (
			<div class="gui_pos_rel">
				<Loader color="#000000" />
			</div>
		)
	}

	return (
		<EntriesMultiGallery
			base_route={`/gallery/`}
			stage={stage.Stage}
			promotion={props.promotion}
			is_logged={props.is_logged}
			avail_participations={avail_participations}
			locale={props.locale}
		/>
	)
}

const Galleries = ({ base_route, ...props }) => {
	return (
		<Router basename={base_route}>
			<Switch>
				<Route exact={true} path="/">
					<GalleryMosaic
						stages={props.stages}
						promotion={props.promotion}
						locale={props.locale}
						participations={props.avail_participations}
					/>
				</Route>

				<Route path="/ranking/:stage_id">
					<MultiEntriesRanking
						base_route={base_route}
						promotion={props.promotion}
						login_id={props.login_id}
						participants={[{}]}
						stages={props.stages}
						is_logged={props.is_logged}
						avail_participations={props.avail_participations}
						locale={props.locale}
					/>
				</Route>

				<Route path="/:stage_id">
					<Gallery
						base_route={base_route}
						stages={props.stages}
						promotion={props.promotion}
						is_logged={props.is_logged}
						locale={props.locale}
					/>
				</Route>
			</Switch>
		</Router>
	)
}

export default injectIntl(Galleries);